import { render, staticRenderFns } from "./adminversion.vue?vue&type=template&id=8948c006&"
import script from "./adminversion.vue?vue&type=script&lang=js&"
export * from "./adminversion.vue?vue&type=script&lang=js&"
import style0 from "./adminversion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports